import { IContentCreator } from "../../../../../redux/reducers/workOrdersReducer";
import { IUser } from "../../../../../types/user/iuser.interface";

import { AvatarList } from "./avatar-list.component";

export const renderAvatarList = (users: IUser[], noUserMessage?: string) => (
  <AvatarList users={users} noUsersMessage={noUserMessage} />
);

export const renderAvatarListFromContentCreators = (
  creators: IContentCreator[],
  noUserMessage?: string
) => {
  const users = creators.map<IUser>((creator) => ({
    ...creator.userDetails,
    showBadge: creator.isCreativePrime,
  }));

  return <AvatarList users={users} noUsersMessage={noUserMessage} />;
};
